import * as React from "react";

type NotificationItem = T.Lib.GetStream.NotificationItem;

function getParamString(
	params: Record<string, string | number | boolean | undefined> | undefined,
	key: string
): string {
	const value = params?.[key];
	return value === undefined || value === null ? "" : String(value);
}

function getParamBoolean(
	params: Record<string, string | number | boolean | undefined> | undefined,
	key: string
): boolean {
	const value = params?.[key];
	return value === true || value === "true";
}

export function renderNotificationTitle(item: NotificationItem): React.ReactNode {
	const { title, title_template, title_params } = item;

	if (title_template === "notification.order_new.title") {
		const orderNumber = getParamString(title_params, "order_number");

		return (
			<>
				{"New Order #"}
				{orderNumber ? (
					<span className="notranslate">{orderNumber}</span>
				) : null}
			</>
		);
	}

	return title;
}

export function renderNotificationBody(item: NotificationItem): React.ReactNode {
	const { body, body_template, body_params } = item;

	if (body_template === "notification.order_new.body") {
		const customerName = getParamString(body_params, "customer_name");
		const avsFailed = getParamBoolean(body_params, "avs_failed");

		return (
			<>
				{customerName ? (
					<span className="notranslate">{customerName}</span>
				) : null}
				{" placed a new order. Click to view the order details"}
				{avsFailed ? " - AVS Check Failed" : ""}
			</>
		);
	}

	return body;
}
